'use client'

import PropTypes from 'prop-types'
import MUIDrawer from '@mui/material/Drawer'
import MUIStack from '@mui/material/Stack'
import MUIIconButton from '@mui/material/IconButton'
import { AddIcon } from '@repo/ui/AddIcon'

export const Drawer = ({ children, headingNode, onClose, isOpen, sx, drawerSx = {} }) => {
  return (
    <div data-testid="Drawer">
      <MUIDrawer
        open={isOpen}
        onClose={onClose}
        anchor="right"
        sx={{ zIndex: '6000', ...drawerSx }}
        PaperProps={{
          sx: { width: window.Office ? '320px' : '520px', backgroundColor: 'white', overflow: 'hidden', display: 'flex', flexDirection: 'column', ...sx }
        }}
      >
        <MUIStack
          data-testid="DrawerHeader"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            p: '24px 16px 23px 24px',
            backgroundColor: 'background.main',
            mb: '24px',
            '@media print': {
              backgroundColor: '#ffffff',
              mb: '0'
            }
          }}
        >
          {headingNode}
          <MUIIconButton onClick={onClose}>
            <AddIcon sx={{ transform: 'rotate(45deg)', width: '24px', height: '24px', opacity: 0.56 }} />
          </MUIIconButton>
        </MUIStack>

        {children}
      </MUIDrawer>
    </div>
  )
}

Drawer.propTypes = {
  children: PropTypes.any,
  headingNode: PropTypes.node,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  sx: PropTypes.object,
  drawerSx: PropTypes.object
}
